<template>
  <el-dialog
    title="商品信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
    customClass="customWidth"
  >
    <el-table
            :data="tableData"
            v-loading="loading"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
      </el-table-column>

      <el-table-column
              label="订单号"
      >
        <template slot-scope="scope">
          {{scope.row.order_id}}
        </template>
      </el-table-column>

      <el-table-column
              label="商品名称"
      >
        <template slot-scope="scope">
          {{scope.row.order_content}}
        </template>
      </el-table-column>
      <el-table-column
              label="商品图片"
      >

        <template slot-scope="scope">


          <div v-if="scope.row.good_url!=null && scope.row.good_url!=''">


             <span v-for="(item,index) in scope.row.good_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl2(scope.row)" @click="previewPic(scope.row)"  style="width: 200px;height: 100px; "/>
              </span>
              </span>
          </span>




          </div>


        </template>
      </el-table-column>
      <el-table-column
              label="单价(元)"
      >
        <template slot-scope="scope">
          {{scope.row.unit_price}}

        </template>
      </el-table-column>
      <el-table-column
              label="数量"
      >
        <template slot-scope="scope">
          {{scope.row.frequency}}
        </template>
      </el-table-column>
      <el-table-column
              label="规格"
      >
        <template slot-scope="scope">
          <div v-html="unEscapeHTML(scope.row.remark)"></div>
        </template>
      </el-table-column>


    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<script>
   import * as agentService from "@/api/sys/agent";
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.getTableData33();
    },
    getImgUrl2(row){
      var good_url=row.good_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
    },
    unEscapeHTML(contnet){
      let parsedJson = JSON.parse(contnet);
      return parsedJson.selectText;
    },
    previewPic(row) {

      var good_url=row.good_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      this.previewpic ="https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;

      this.dialogVisible = true;

    },
    getTableData33() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        order_id: this.oneclass.order_id,
        descending: this.sort.order === "descending"
      };
      agentService.getMobileOrderPagelistGw(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData33();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData33();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData33();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData33();
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>
<style>
  .customWidth{
    width:80%;
  }
</style>
